import {
  Accordion,
  Card,
  CardHead,
  Header,
  HeaderArt,
  HeaderSub,
  HeaderTitle,
  List,
  Num,
  SecHead,
  Section,
  TwoCol,
  Wrap,
} from './guideUi';

/** 셔틀버스 운행 안내 — 네이티브 인포그래픽. */
const ShuttleGuide = () => {
  return (
    <Wrap>
      <Header>
        <HeaderArt aria-hidden>
          <svg viewBox='0 0 48 48' fill='none'>
            <rect
              x='7'
              y='10'
              width='34'
              height='22'
              rx='4'
              fill='rgba(255,255,255,0.16)'
              stroke='#fff'
              strokeWidth='2'
            />
            <path
              d='M7 21h34M13 15h9M26 15h9'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <circle cx='15' cy='37' r='3' stroke='#fff' strokeWidth='2' />
            <circle cx='33' cy='37' r='3' stroke='#fff' strokeWidth='2' />
          </svg>
        </HeaderArt>
        <HeaderTitle>셔틀버스 운행 안내</HeaderTitle>
        <HeaderSub>제주공항 ↔ 본사 무료 셔틀을 운행합니다.</HeaderSub>
      </Header>

      <Section>
        <SecHead>
          <Num>1</Num> 탑승 장소
        </SecHead>
        <List>
          <li>
            제주공항 1층 <b>5번 게이트</b>로 나와 횡단보도를 두 번 건너세요.
          </li>
          <li>
            렌트카하우스 좌측 <b>8구역 3번 승차장</b>에서 제주로렌트카 셔틀을
            탑승합니다.
          </li>
        </List>
      </Section>

      <Section>
        <SecHead>
          <Num>2</Num> 운행 시간
        </SecHead>
        <TwoCol>
          <Card>
            <CardHead>공항 출발 (본사행)</CardHead>
            <List>
              <li>07:50 ~ 21:45</li>
              <li>08~20시 15분 간격 순환</li>
              <li>야간: 20:15 / 20:45 / 21:15 / 21:45</li>
            </List>
          </Card>
          <Card>
            <CardHead>본사 출발 (공항행)</CardHead>
            <List>
              <li>06:30 ~ 20:00</li>
              <li>08~20시 15분 간격 순환</li>
              <li>새벽: 06:30 / 07:00 / 07:30</li>
            </List>
          </Card>
        </TwoCol>
      </Section>

      <Accordion num={3} title='셔틀 이용 유의사항'>
        <List>
          <li>
            본사 → 공항 마지막 셔틀은 20:00입니다. 이후에는 개별 이동하셔야
            합니다.
          </li>
          <li>22:00까지 인수가 어려우면 익일 인수하시기 바랍니다.</li>
          <li>비행기 지연 시에도 동일하게 적용됩니다.</li>
        </List>
      </Accordion>
    </Wrap>
  );
};

export default ShuttleGuide;
